import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.css']
})
export class TabsComponent implements OnInit {

  public activePath: string;
  public activeProject!: string;

  public tabs: any = [
    {
      path: 'exceptions',
      label: 'Exceptions'
    },
    // {
    //   path: 'analytics',
    //   label: 'Analytics'
    // },
    {
      path: 'analytics',
      label: 'Analytics & Logs'
    },
    {
      path: 'settings',
      label: 'Settings'
    }
  ]

  constructor(
    private commonService: CommonService,
    private localStorage: LocalStorageService,
    private router: Router,
  ) {
    this.activePath = window.location.href.split('/')[window.location.href.split('/').length - 1];
  }

  /**
   * loads on component initialization
   */
  ngOnInit(): void {
    this.commonService.updateSidebarObservable.subscribe({
      next: (updateStatus: boolean) => {
        if (updateStatus) {
          this.activeProject = this.localStorage.get('projectId')!;
        }
      }
    })
    this.activeProject = this.localStorage.get('projectId')!;

  }

  public redirectPage(path: string) {
    this.router.navigate([`/project/${this.activeProject}/${path}`]);
  }
}
